import { useQuery } from "@tanstack/react-query"
import { axios } from "apis/axios"
import { ExtractFnReturnType, QueryConfig } from "apis/queryConfig"
import { IInsightGraphFilterData } from "types/ActionTrackerGraphs"

type IgetATIGraphFilters={
  project_id: string | undefined
}

function getATIGraphFilters({project_id}: IgetATIGraphFilters): Promise<IInsightGraphFilterData> {
  return axios.get(`/oe/action-management/project/${project_id}/filters-dropdown`
  ).then(res => res.data as any)
}

type QueryFnType = typeof getATIGraphFilters
type IuseATIGraphFilterData ={
  config: QueryConfig<QueryFnType>
} & IgetATIGraphFilters

export const useATIGraphFilterData = ({project_id, config}:IuseATIGraphFilterData ) =>{
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ["ATIGraphFilters", project_id],
    queryFn: () => getATIGraphFilters({ project_id }),
    enabled:!!project_id,
   ...config,
  })
}